"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.channelConfig = exports.Compilation = void 0;
var adboost_1 = __importDefault(require("./logo/adboost"));
var ap_1 = __importDefault(require("./logo/ap"));
var bt_1 = __importDefault(require("./logo/bt"));
var e24_1 = __importDefault(require("./logo/e24"));
var facebook_1 = __importDefault(require("./logo/facebook"));
var finn_rec_1 = __importDefault(require("./logo/finn-rec"));
var finn_resultpage_1 = __importDefault(require("./logo/finn-resultpage"));
var mail_1 = __importDefault(require("./logo/mail"));
var map_1 = __importDefault(require("./logo/map"));
var fvn_1 = __importDefault(require("./logo/fvn"));
var sa_1 = __importDefault(require("./logo/sa"));
var vg_1 = __importDefault(require("./logo/vg"));
var adressa_1 = __importDefault(require("./logo/adressa"));
var schibsted_1 = __importDefault(require("./logo/schibsted"));
var bladet_1 = __importDefault(require("./logo/bladet"));
var driva_1 = __importDefault(require("./logo/driva"));
var fosnafolket_1 = __importDefault(require("./logo/fosnafolket"));
var innherred_1 = __importDefault(require("./logo/innherred"));
var itromso_1 = __importDefault(require("./logo/itromso"));
var sunnmorsposten_1 = __importDefault(require("./logo/sunnmorsposten"));
var tronderbladet_1 = __importDefault(require("./logo/tronderbladet"));
var rbnett_1 = __importDefault(require("./logo/rbnett"));
var vol_1 = __importDefault(require("./logo/vol"));
var vikebladet_1 = __importDefault(require("./logo/vikebladet"));
var vestlandsnytt_1 = __importDefault(require("./logo/vestlandsnytt"));
var vigga_1 = __importDefault(require("./logo/vigga"));
var fjordingen_1 = __importDefault(require("./logo/fjordingen"));
var altaposten_1 = __importDefault(require("./logo/altaposten"));
var andalsnesavis_1 = __importDefault(require("./logo/andalsnesavis"));
var avisast_1 = __importDefault(require("./logo/avisast"));
var banett_1 = __importDefault(require("./logo/banett"));
var dolen_1 = __importDefault(require("./logo/dolen"));
var fjordabladet_1 = __importDefault(require("./logo/fjordabladet"));
var fjordenestidende_1 = __importDefault(require("./logo/fjordenestidende"));
var fjuken_1 = __importDefault(require("./logo/fjuken"));
var folkebladet_1 = __importDefault(require("./logo/folkebladet"));
var framtidinord_1 = __importDefault(require("./logo/framtidinord"));
var firdatidend_1 = __importDefault(require("./logo/firdatidend"));
var hitrafroya_1 = __importDefault(require("./logo/hitrafroya"));
var harstadtidende_1 = __importDefault(require("./logo/harstadtidende"));
var opp_1 = __importDefault(require("./logo/opp"));
var morenytt_1 = __importDefault(require("./logo/morenytt"));
var nyss_1 = __importDefault(require("./logo/nyss"));
var tek_1 = __importDefault(require("./logo/tek"));
var instagram_1 = __importDefault(require("./logo/instagram"));
var logo_1 = require("./logo");
Object.defineProperty(exports, "Compilation", { enumerable: true, get: function () { return __importDefault(logo_1).default; } });
function channelConfig(channel) {
    switch (channel) {
        case 'adboost':
            return {
                name: 'adboost',
                logo: adboost_1.default,
                reach: 'internal',
                color: '#ffffff',
                backgroundColor: '#0387B1',
            };
        case 'schibsted':
            return {
                name: 'Schibsted',
                logo: schibsted_1.default,
                reach: 'national',
                color: '#ffffff',
                backgroundColor: '#31312f',
            };
        case 'adressa.no':
            return {
                name: 'Adressa',
                logo: adressa_1.default,
                reach: 'regional',
                color: '#ffffff',
                backgroundColor: '#1C3661',
            };
        case 'aftenbladet.no':
            return {
                name: 'Stavanger Aftenblad',
                logo: sa_1.default,
                reach: 'regional',
                color: '#ffffff',
                backgroundColor: '#005693',
            };
        case 'altaposten':
            return {
                name: 'Altaposten',
                logo: altaposten_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#1a3281',
            };
        case 'andalsnes-avis':
            return {
                name: 'Åndalsnes Avis',
                logo: andalsnesavis_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#3f72ae',
            };
        case 'ap.no':
        case 'aftenposten.no':
            return {
                name: 'Aftenposten',
                logo: ap_1.default,
                reach: 'regional',
                color: '#ffffff',
                backgroundColor: '#000C26',
            };
        case 'avisast':
            return {
                name: 'Avisa Sør-Trøndelag',
                logo: avisast_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#0061af',
            };
        case 'banett':
            return {
                name: 'Brønnøysunds Avis',
                logo: banett_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#0077c0',
            };
        case 'bladet':
            return {
                name: 'Bladet',
                logo: bladet_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#c9252c',
            };
        case 'bt.no':
            return {
                name: 'Bergens Tidende',
                logo: bt_1.default,
                reach: 'regional',
                color: '#ffffff',
                backgroundColor: '#00BAF2',
            };
        case 'dolen':
            return {
                name: 'Dølen',
                logo: dolen_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#ce1113',
            };
        case 'driva':
            return {
                name: 'Driva',
                logo: driva_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#d91a21',
            };
        case 'e24':
            return {
                name: 'E24',
                logo: e24_1.default,
                reach: 'national',
                color: '#fffbf8',
                backgroundColor: '#1c1d1f',
            };
        case 'facebook':
            return {
                name: 'Facebook',
                logo: facebook_1.default,
                reach: 'social',
                color: '#ffffff',
                backgroundColor: '#0062E0',
            };
        case 'instagram':
            return {
                name: 'Instagram',
                logo: instagram_1.default,
                reach: 'social',
                color: '#ffffff',
                backgroundColor: '#B902B3',
            };
        case 'finn-mail':
            return {
                name: 'FINN e-post',
                logo: mail_1.default,
                reach: 'internal',
                color: '#ffffff',
                backgroundColor: '#01B7A7',
            };
        case 'finn-map':
            return {
                name: 'FINN kart',
                logo: map_1.default,
                reach: 'internal',
                color: '#ffffff',
                backgroundColor: '#F99459',
            };
        case 'finn-rec':
            return {
                name: 'Anbefalinger på FINN',
                logo: finn_rec_1.default,
                reach: 'internal',
                color: '#ffffff',
                backgroundColor: '#4F46E5',
            };
        case 'finn-resultpage':
            return {
                name: 'Øverst i listen på FINN',
                logo: finn_resultpage_1.default,
                reach: 'internal',
                color: '#ffffff',
                backgroundColor: '#4F46E5',
            };
        case 'fjordingen':
            return {
                name: 'Fjordingen',
                logo: fjordingen_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#0072bc',
            };
        case 'fjordabladet':
            return {
                name: 'Fjordabladet',
                logo: fjordabladet_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#0062a3',
            };
        case 'fjt':
            return {
                name: 'Fjordenes Tidende',
                logo: fjordenestidende_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#0079c2',
            };
        case 'fjuken':
            return {
                name: 'Fjuken',
                logo: fjuken_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#906',
            };
        case 'folkebladet':
            return {
                name: 'Folkebladet',
                logo: folkebladet_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#00537b',
            };
        case 'fosnafolket':
            return {
                name: 'Fosnafolket',
                logo: fosnafolket_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#c92434',
            };
        case 'framtidinord':
            return {
                name: 'Framtid i Nord',
                logo: framtidinord_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#274471',
            };
        case 'firdatidend':
            return {
                name: 'Firda Tidend',
                logo: firdatidend_1.default,
                reach: 'local',
                color: '#31312f',
                backgroundColor: '#ffffff',
            };
        case 'fvn.no':
            return {
                name: 'Fædrelandsvennen',
                logo: fvn_1.default,
                reach: 'regional',
                color: '#ffffff',
                backgroundColor: '#1C1E57',
            };
        case 'hitrafroya':
            return {
                name: 'Hitra-Frøya',
                logo: hitrafroya_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#0d6f9f',
            };
        case 'ht':
            return {
                name: 'Harstad Tidende',
                logo: harstadtidende_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#32477c',
            };
        case 'innherred':
            return {
                name: 'Innherred',
                logo: innherred_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#f15a23',
            };
        case 'itromso':
            return {
                name: 'iTromsø',
                logo: itromso_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#004a8f',
            };
        case 'morenytt':
            return {
                name: 'Møre-Nytt',
                logo: morenytt_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#002a52',
            };
        case 'opp':
            return {
                name: 'OPP',
                logo: opp_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#26828a',
            };
        case 'opdalingen':
            return {
                name: 'Oppdalingen',
                logo: opp_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#26828a',
            };
        case 'rbnett':
            return {
                name: 'Romsdals Budstikke',
                logo: rbnett_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#1b71ae',
            };
        case 'smp':
            return {
                name: 'Sunnmørsposten',
                logo: sunnmorsposten_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#004f9f',
            };
        case 'sunnmoringen':
            return {
                name: 'Sunnmøringen',
                logo: nyss_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#b30024',
            };
        case 'nyss':
            return {
                name: 'Nyss',
                logo: nyss_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#b30024',
            };
        case 'tek':
            return {
                name: 'Tek.no',
                logo: tek_1.default,
                reach: 'national',
                color: '#ffffff',
                backgroundColor: '#21B4C7',
            };
        case 'tronderbladet':
            return {
                name: 'Trønderbladet',
                logo: tronderbladet_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#034ea2',
            };
        case 'vestlandsnytt':
            return {
                name: 'Vestlandsnytt',
                logo: vestlandsnytt_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#ec1c24',
            };
        case 'vigga':
            return {
                name: 'Vigga',
                logo: vigga_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#ce282c',
            };
        case 'vikebladet':
            return {
                name: 'Vikebladet',
                logo: vikebladet_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#c1342e',
            };
        case 'vg.no':
            return {
                name: 'VG',
                logo: vg_1.default,
                reach: 'national',
                color: '#ffffff',
                backgroundColor: '#d00000',
            };
        case 'vol':
            return {
                name: 'Vesterålen Online',
                logo: vol_1.default,
                reach: 'local',
                color: '#ffffff',
                backgroundColor: '#194c85',
            };
        default:
            return { name: channel, logo: null, reach: 'local' };
    }
}
exports.channelConfig = channelConfig;
